import React, { useEffect, useState } from "react";
import Page from "../../component/Page";
import { getBranchList, getCatalogList } from "../setting/services/settingApi";
import api from "../../api/api";
import { saveAs } from "file-saver";
import {
  Autocomplete,
  Box,
  Button,
  CircularProgress,
  FormControl,
  Menu,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import { REPORT_CONFIG } from "./config";
import { MobileDatePicker } from "@mui/x-date-pickers";
import { PLAN_CONFIG } from "../plan/config";
const BrowserInput = function BrowserInput(props) {
  const {
    inputProps,
    InputProps,
    ownerState,
    value,
    inputRef,
    error,
    ...other
  } = props;
  return (
    <TextField
      {...inputProps}
      ref={inputRef}
      value={
        value
          ? value.substring(0, value?.length - 6) +
            (parseInt(value?.substring(value?.length - 6)) + 543).toString()
          : null
      }
      {...other}
      variant="standard"
      fullWidth
      InputProps={{
        disableUnderline: true,
      }}
    />
  );
};
export default function ReportDelvieryTen() {
  const [branchs, setBranchs] = useState([]);
  const [PlanDelviery, setPlanDelviery] = useState([]);
  const [ItemNo, setItemNo] = useState();
  const [BranchNo, setBranchsNo] = useState("");
  // const [startDate, setStartDate] = useState(dayjs(new Date()).subtract(1, 'day'))
  const [docdate, setdocdate] = useState();
  const [reports, setReports] = useState([]);
  const [sumValue, setSumValue] = useState();
  const [loadingDownload, setloadingDownload] = useState(false);
  const [loading, setloading] = useState(false);
  const [error, setError] = useState(false);

  const { profile } = useSelector((state) => state.profile);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    if (!ItemNo) {
      setError(true);
    } else {
      setAnchorEl(event.currentTarget);
    }
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  async function getDeliveryDoc(e) {
    const res = await api.get(PLAN_CONFIG.requests.getPlanDelvieryDoc.url);
    const data = res.data.result;
    const selectedDate = new Date(e).toLocaleDateString() || undefined;
    let docs = [...data];

    if (e) {
      docs = docs.filter((x) => {
        return (
          new Date(x.DeliveryDocDate).toLocaleDateString() === selectedDate
        );
      });
    }
    setItemNo(null);
    setPlanDelviery(docs);
  }
  useEffect(() => {
    getBranchList(null, setBranchs);
    LoadReport();
    getDeliveryDoc();
  }, []);

  useEffect(() => {
    setBranchsNo(profile?.BranchNo?.BranchNo);
  }, [profile]);
  function calculateSum() {
    const sumValue = { Qty: 0 };

    for (const row of reports) {
      sumValue.Qty += +row.Qty;
    }
    setSumValue(sumValue);
  }
  useEffect(() => {
    calculateSum();
  }, [reports]);

  function searchChange(e) {
    const selectedDate = dayjs(e).format("YYYY-MM-DD") || undefined;
    let docs = [...PlanDelviery];

    if (selectedDate) {
      docs = docs.filter((e) => {
        return (
          new Date(e.DeliveryDocDate).toLocaleDateString() === selectedDate
        );
      });
      setPlanDelviery(docs);
    }
  }

  async function getReportDelivery10(body, mode, format) {
    const url = `${REPORT_CONFIG.requests.getDelivery10Report.url}/${mode}`;

    let _params = "";
    let _deliveryDocNo = "";

    let _branchNo = "";
    let _deliveryDocDate = "";
    let _format = "";

    if (body.deliveryDocNo) {
      _deliveryDocNo = "deliveryDocNo=" + body.deliveryDocNo;
    }

    if (body.branchNo) {
      _branchNo = "&branchNo=" + (body.branchNo !== "-" ? body.branchNo : "");
    }
    if (body.deliveryDocDate) {
      _deliveryDocDate = "&deliveryDocDate=" + body.deliveryDocDate;
    }

    if (format) {
      _format = "&format=" + format;
    }
    _params = "?" + _deliveryDocNo + _branchNo + _deliveryDocDate + _format;
    if (mode === "file") {
      setloadingDownload(true);
      const res = await api.get(url + _params, { responseType: "arraybuffer" });
      const data = res.data;
      if (format) {
        const blob = new Blob([data], { type: "application/pdf" });
        saveAs(blob, "รายงานสรุปผลการจัดส่งเมล็ดพันธุ์ (กมข-30404)");
      } else {
        const blob = new Blob([data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        saveAs(blob, "รายงานสรุปผลการจัดส่งเมล็ดพันธุ์ (กมข-30404)");
      }
      setloadingDownload(false);
    } else {
      setloading(true);
      const res = await api.get(url + _params);
      const data = res.data.result;
      setReports(data);
      setloading(false);
    }
  }
  async function LoadReport(e) {
    e.preventDefault();
    const body = {
      deliveryDocNo: ItemNo?.DeliveryDocNo,
      branchNo: BranchNo || undefined,
      deliveryDocDate: docdate ? dayjs(docdate).format("YYYY-MM-DD") : "",
    };
    if (!ItemNo) {
      setError(true);
    } else {
      getReportDelivery10(body, "data");
    }
  }

  return (
    <div style={{ padding: "10px 30px" }}>
      <Page>
        <div class="container-fluid p-0">
          <form onSubmit={(e) => LoadReport(e)}>
            <div class="row  no-gutters">
              <div class="col-12 col-lg-2">
                <div class="row no-gutters">
                  <div class="col-12 header-row border-1 ">ตัวกรอง</div>
                </div>
                <div class="row no-gutters p-2 border-1">
                  {profile?.BranchNo?.BranchNo === "00" && (
                    <div class="col-12">
                      <label class="labelInput">ศูนย์เมล็ดพันธุ์ข้าว</label>
                      <Box
                        className="backgroundField"
                        sx={{ marginBottom: "10px" }}
                      >
                        <FormControl variant="standard" fullWidth>
                          <Select
                            value={BranchNo || "-"}
                            onChange={(e) => setBranchsNo(e.target.value)}
                            disableUnderline
                          >
                            <MenuItem value="-">-</MenuItem>
                            {branchs?.map((x) => (
                              <MenuItem value={x?.BranchNo}>
                                {x?.BranchName}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Box>
                    </div>
                  )}
                  <div class="col-12">
                    <label class="labelInput">ลงวันที่ (บัญชีจัดส่ง)</label>
                    <Box
                      className="backgroundField"
                      sx={{ marginBottom: "20px", borderRadius: "25px" }}
                    >
                      <MobileDatePicker
                        dayOfWeekFormatter={(day) => `${day}`}
                        value={docdate}
                        onChange={(e) => {
                          setdocdate(e);
                          // searchChange(e)
                          getDeliveryDoc(e);
                          setItemNo(null);
                        }}
                        slotProps={{
                          textField: {
                            variant: "standard",
                            fullWidth: true,
                            InputProps: { disableUnderline: true },
                            value: docdate,
                          },
                        }}
                        slots={{
                          textField: BrowserInput,
                        }}
                      />
                    </Box>
                  </div>
                  <div class="col-12">
                    <label class="labelInput">(เลขที่หนังสือ) โครงการ</label>
                    <Box className={`backgroundField ${error ? "error" : ""}`}>
                      <Autocomplete
                        fullWidth
                        size="small"
                        options={PlanDelviery}
                        getOptionLabel={(option) => option?.DeliveryDocNo}
                        // renderOption={(props, option) => (
                        //     <Box component="li" {...props} key={option.ItemId}>
                        //         {option?.CatalogNo?.CatalogName} {option?.Option2} {option?.Season} {option?.Option1} {option?.Chemical}
                        //     </Box>
                        // )}
                        value={ItemNo || { DeliveryDocNo: "" }}
                        onChange={(event, newValue) => {
                          setItemNo(newValue);

                          // getLots(newValue?.ItemNo)
                        }}
                        onBlur={(e) => {
                          if (!e.target.value) {
                            setError(true);
                          } else {
                            setError(false);
                          }
                        }}
                        renderInput={(params) => (
                          // <TextField {...params} variant="standard" fullWidth placeholder="ค้นหา เลขที่เอกสาร"
                          //     InputProps={{
                          //         disableUnderline: true,
                          //         startAdornment: <Box sx={{ marginRight: '10px' }}><FontAwesomeIcon icon={faSearch} /></Box>,
                          //     }}
                          // />
                          <TextField {...params} fullWidth variant="standard" />
                        )}
                      />
                    </Box>
                    {error && (
                      <span style={{ color: "red", fontSize: "12px" }}>
                        กรุณาเลือกเลขที่หนังสือ
                      </span>
                    )}
                  </div>

                  <div class="col-12 mt-3">
                    <Button
                      onClick={LoadReport}
                      disabled={loading ? true : false}
                      variant="contained"
                      className="ButtomSearch"
                    >
                      {loading ? (
                        <CircularProgress size={"18px"} color="inherit" />
                      ) : (
                        "ค้นหา"
                      )}{" "}
                    </Button>
                  </div>
                </div>
              </div>
              <div class="col-12 col-lg-10">
                <div class="row no-gutters">
                  <div class="col-12 d-flex justify-content-between header-row border-1 ">
                    <div>รายงานสรุปผลการจัดส่งเมล็ดพันธุ์ (กมข-30404)</div>
                    <Button
                      variant="contained"
                      id="basic-button"
                      aria-controls={open ? "basic-menu" : undefined}
                      aria-haspopup="true"
                      aria-expanded={open ? "true" : undefined}
                      disabled={loadingDownload ? true : false}
                      onClick={handleClick}
                    >
                      {loadingDownload ? (
                        <CircularProgress size={"18px"} color="inherit" />
                      ) : (
                        "ดาวน์โหลด"
                      )}
                    </Button>
                    <Menu
                      id="basic-menu"
                      anchorEl={anchorEl}
                      open={open}
                      onClose={handleClose}
                      MenuListProps={{
                        "aria-labelledby": "basic-button",
                      }}
                      PaperProps={{
                        style: {
                          width: 100,
                        },
                      }}
                    >
                      <MenuItem
                        onClick={() => {
                          const body = {
                            deliveryDocNo: ItemNo?.DeliveryDocNo,
                            branchNo: BranchNo || undefined,
                            deliveryDocDate: docdate
                              ? dayjs(docdate).format("YYYY-MM-DD")
                              : "",
                          };
                          getReportDelivery10(body, "file");

                          handleClose();
                        }}
                      >
                        Excel
                      </MenuItem>
                      <MenuItem
                        onClick={() => {
                          const body = {
                            deliveryDocNo: ItemNo?.DeliveryDocNo,
                            branchNo: BranchNo || undefined,
                            deliveryDocDate: docdate
                              ? dayjs(docdate).format("YYYY-MM-DD")
                              : "",
                          };
                          getReportDelivery10(body, "file", "pdf");

                          handleClose();
                        }}
                      >
                        Pdf
                      </MenuItem>
                    </Menu>
                  </div>
                </div>
                <div class="row no-gutters border-1 pt-3">
                  <div class="report col-12">
                    <div class="table-responsive-sm" style={{ height: "auto" }}>
                      <table class="table table-bordered table-sm table-hover">
                        <thead class="sticky-thead">
                          <tr>
                            <th scope="col " rowspan="2" class="text-center">
                              ที่
                            </th>
                            <th scope="col " rowspan="2" class="text-center">
                              พันธุ์
                            </th>
                            <th scope="col " rowspan="2" class="text-center">
                              ชั้นพันธุ์
                            </th>
                            <th scope="col " rowspan="2" class="text-center">
                              ฤดู
                            </th>
                            <th scope="col " rowspan="2" class="text-center">
                              ปี
                            </th>
                            <th scope="col " rowspan="2" class="text-center">
                              ประเภทเงินที่ใช้ผลิต
                            </th>
                            <th scope="col " rowspan="2" class="text-center">
                              จังหวัด ที่จัดส่ง
                            </th>
                            <th scope="col " rowspan="2" class="text-center">
                              อำเภอ ที่จัดส่ง
                            </th>
                            <th scope="col " rowspan="2" class="text-center">
                              จำนวน (กิโลกรัม)
                            </th>
                            <th scope="col " rowspan="2" class="text-center">
                              วัน/เดือน/ปี ที่จัดส่ง
                            </th>
                            <th scope="col " colspan="2" class="text-center">
                              จัดส่งโดย
                            </th>
                            <th scope="col " rowspan="2" class="text-center">
                              หมายเหตุ
                            </th>
                          </tr>
                          <tr>
                            <th scope="col " class="text-center">
                              รถเอกชน
                            </th>
                            <th scope="col " class="text-center">
                              รถศูนย์
                            </th>
                          </tr>
                        </thead>
                        <tbody class="">
                          {reports?.map((d, i) => (
                            <tr>
                              <td class="text-center">{i + 1}</td>
                              <td class="text-center">{d?.CatalogName}</td>
                              <td class="text-center">{d?.Option2}</td>
                              <td class="text-center">{d?.Season}</td>
                              <td class="text-center">{d?.Year}</td>
                              <td class="text-center">{d?.MoneyType}</td>
                              <td class="text-center">{d?.Province}</td>
                              <td class="text-center">{d?.District}</td>
                              <td class="text-center">
                                {d?.Qty.toLocaleString()}
                              </td>
                              <td class="text-center">{d?.DeliveryDate}</td>
                              <td class="text-center">{d?.Outsource}</td>
                              <td class="text-center">{d?.SelfTruck}</td>
                              <td class="text-center">{d?.Remark}</td>
                            </tr>
                          ))}
                        </tbody>
                        <thead class="sticky-tfooter">
                          <tr>
                            <th scope="col " colspan="8" class="text-center">
                              รวม
                            </th>
                            <th scope="col " class="text-center">
                              {sumValue?.Qty.toLocaleString()}
                            </th>
                            <th
                              scope="col "
                              colspan="4"
                              class="text-center"
                            ></th>
                          </tr>
                        </thead>
                      </table>
                    </div>
                  </div>
                </div>
                {reports.length === 0 && (
                  <div class="row">
                    <div class="col-12">
                      <div class="not-found">ไม่พบข้อมูล</div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </form>
        </div>
      </Page>
    </div>
  );
}
